import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as ImportConstants from './ImportConstants';

export const getImportFormat = (type) => {
  let url = '';
  console.log('tupe', type);
  switch (type) {
    case 'imagesNotPursuable':
      url = API.GET_NOT_PURSUABLE_FORMAT;
      break;
    case 'imagesRegistered':
      url = API.GET_REGISTERED_ASSET_FORMAT;
      break;
    case 'domainsBlacklisted':
      url = API.GET_BLACKLISTED_DOMAIN;
      break;
    case 'imagesStatuses':
      url = API.GET_IMAGES_STATUS_FORMAT;
      break;
    case 'subdomainsBlacklisted':
      url = API.GET_BLACKLISTED_DOMAIN;
      break;
    case 'agency':
      url = API.GET_AGENCY_FORMAT;
      break;
    case 'countries':
      url = API.GET_COUNTRIES_FORMAT;
      break;
    default:
      url = API.GET_NOT_PURSUABLE_FORMAT;
      break;
  }
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(url)}`,
      types: [
        ImportConstants.GET_FORMAT_REQUEST,
        ImportConstants.GET_FORMAT_SUCCESS,
        ImportConstants.GET_FORMAT_FAILED
      ]
    }
  };
};

export const loadUpdatedData = (type, requestData) => {
  let url = '';
  switch (type) {
    case 'imagesNotPursuable':
      url = API.LOAD_NOT_PURSUABLE_BATCH;
      break;
    case 'imagesRegistered':
      url = API.LOAD_REGISTERED_ASSET_BATCH;
      break;
    case 'domainsBlacklisted':
      url = API.LOAD_BLACKLISTED_DOMAIN_BATCH;
      break;
    case 'imagesStatuses':
      url = API.LOAD_STATUSES_BATCH;
      break;
    case 'subdomainsBlacklisted':
      url = API.LOAD_BLACKLISTED_SUBDOMAIN_BATCH;
      break;
    default:
      url = API.LOAD_NOT_PURSUABLE_BATCH;
      break;
  }
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: `${apiEndpoints().entity(url)}`,
      types: [
        ImportConstants.LOAD_UPDATE_REQUEST,
        ImportConstants.LOAD_UPDATE_SUCCESS,
        ImportConstants.LOAD_UPDATE_FAILED
      ]
    }
  };
};

export const loadImportedData = (type, importedFile) => {
  let url = '';
  switch (type) {
    case 'imagesNotPursuable':
      url = API.LOAD_NOT_PURSUABLE_CSV;
      break;
    case 'imagesRegistered':
      url = API.LOAD_REGISTERED_ASSET_CSV;
      break;
    case 'domainsBlacklisted':
      url = API.LOAD_BLACKLISTED_DOMAIN_CSV;
      break;
    case 'imagesStatuses':
      url = API.LOAD_STATUSES_CSV;
      break;
    case 'subdomainsBlacklisted':
      url = API.LOAD_BLACKLISTED_SUBDOMAIN_CSV;
      break;
    case 'countries':
      url = API.LOAD_COUNTRIES_CSV;
      break;
    case 'agency':
      url = API.LOAD_LEGITIMATE_AGENCY_CSV;
      break;
    default:
      url = API.LOAD_NOT_PURSUABLE_CSV;
      break;
  }

  const formData = new FormData();
  formData.append('file', importedFile);

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: formData,
        redirect: 'follow'
      },
      endpoint: `${apiEndpoints().entity(url)}`,
      types: [
        ImportConstants.LOAD_IMPORT_REQUEST,
        ImportConstants.LOAD_IMPORT_SUCCESS,
        ImportConstants.LOAD_IMPORT_FAILED
      ]
    }
  };
};
